import URL from 'url';
import logToDataDog from 'src/config/logToDataDog';
import getBootstrap from '../ssr/Booking/data/fetchBootstrap-shared';

const logBootstrap = (page, isError) => {
    const event = {
        name: 'booking-web-app.bootstrap',
        type: 'increment',
        value: 1,
        tags: [
            isError ? 'status:failed' : 'status:success',
            `page:${page}`,
            `marketplace:true`,
        ],
    };

    logToDataDog(event);
};

export default function fetchBootstrap(url) {
    const parsedUrl = URL.parse(url);
    const splitPath = parsedUrl.pathname.split('/');
    const page = splitPath[2];
    const bookingId = splitPath[splitPath.length - 1];

    return getBootstrap({
        fetchFunc: (u) => fetchWithRetries(u, { retries: 3 }),
        url,
        bookingId,
    })
        .then((data) => {
            logBootstrap(page, false);
            return data;
        })
        .catch(() => {
            logBootstrap(page, true);
            return {
                bootstrapFailed: true,
                bookingId,
            };
        });
}
